import { useCesiumContext } from "./CesiumContext";
import { isDefined } from "../../lib/utils";
import { createPortal } from "react-dom";

export default function ScreenSpacePoint({
  position
}: {
  position: number[];
}) {
  const { map } = useCesiumContext();

  if (
    !isDefined(map.scene.canvas.parentElement) ||
    !isDefined(position[0]) ||
    !isDefined(position[1])
  )
    return;
  return createPortal(
    <div
      style={{ left: `${position[0]}px`, top: `${position[1]}px` }}
      className="absolute -translate-x-1/2 -translate-y-1/2 w-[8px] h-[8px] flex justify-center items-center border-2 border-red-500 top-0 left-0 rounded-full"
    ></div>,
    map.scene.canvas.parentElement
  );
}
